import { useAppSelector } from 'universal-scripts'

interface UseResourcePermissionsResult {
  isCompanyOwner: boolean
  isIndividualOwner: boolean
  canEdit: boolean
}

export function useResourcePermissions(
  ownerId: string | undefined | null
): UseResourcePermissionsResult {
  const currentUser = useAppSelector((state) => state.user)

  if (!ownerId || !currentUser) {
    return {
      isCompanyOwner: false,
      isIndividualOwner: false,
      canEdit: false
    }
  }

  const isCompanyOwner = Boolean(
    currentUser.company_id && currentUser.company_id === ownerId
  )

  const isIndividualOwner = Boolean(
    currentUser.id && currentUser.id === ownerId
  )

  return {
    isCompanyOwner,
    isIndividualOwner,
    canEdit: isCompanyOwner || isIndividualOwner
  }
}
